"use strict";

import {BaseElement} from "../interfaces/BaseElement";
import {changeLangToCurrent, getCurrentLang} from "./langSwitcher/langSwitcher";
import gsap from "gsap";
import {createHtmlElement, getUrlParam} from "../../functions";
import { DreamsPreloader } from './preloader/DreamsPreloader';

export class Banner extends BaseElement {
  #root;
  #wrapper;
  #configData;
  #preloader = null;

  constructor(configData) {
    super();

    this.#configData = configData;
    if (!this.#configData.active)
      return;

    this.#root = this;
    this.#root
      .addClass('banner', this.#configData.name)
      .appendTo(document.body);

    this.#addElements();
    this.#show();
  }

  #addElements() {
    this.#wrapper = new BaseElement()
      .addClass('banner__wrapper')
      .event('click', this.#clickActionHandler.bind(this))
      .appendTo(this.#root.DOMElement);

    const contentWrapper = new BaseElement()
      .addClass('banner__content-wrapper')
      .appendTo(this.#wrapper.DOMElement);

    const titleConfigData = this.#configData.title;
    const title = new BaseElement('h3')
      .addClass('banner__title')
      .appendTo(contentWrapper.DOMElement);
    this.#addTranslationToElement(title, titleConfigData);

    const subTitle = new BaseElement('div')
      .addClass('banner__sub-title')
      .appendTo(contentWrapper.DOMElement);

    const subTitleConfigData = this.#configData.subTitle;
    const subtitleText = new BaseElement('h5')
      .addClass('banner__sub-text')
      .appendTo(subTitle.DOMElement);
    this.#addTranslationToElement(subtitleText, subTitleConfigData);

    const actionButtonConfigData = this.#configData.actionButton.title;
    if (actionButtonConfigData) {
      const actionButton = new BaseElement('button')
        .addClass('banner__action-button')
        .appendTo(subTitle.DOMElement);
      this.#addTranslationToElement(actionButton, actionButtonConfigData);
    }

    new BaseElement('button')
      .addClass('banner__close-button', 'close-button-cross')
      .appendTo(this.#wrapper.DOMElement);

    new BaseElement('span')
      .addClass('banner__icon', 'icon-horn')
      .appendTo(this.#wrapper.DOMElement);
  }

  #clickActionHandler(event) {
    if (!event.target.classList.contains('banner__close-button')) {
      switch(this.#configData.actionButton.action) {
        case 'iframe':
          this.#createIframe();
          break;
        case 'tab':
          this.#openTab();
          break;
      }
    }

    gsap.to(this.DOMElement, {
      duration: 0.75,
      scale: 0,
      onComplete: () => {
        this.remove();
      }
    });
  }

  #createIframe() {
    const iframeContainer = new BaseElement()
      .addClass('banner__iframe-container')
      .appendTo(document.body);

    this.#addPreloader(iframeContainer.DOMElement);

    const iframeWrapper = new BaseElement()
      .addClass('banner__iframe-wrapper')
      .appendTo(iframeContainer.DOMElement);

    const iframe = new BaseElement('iframe')
      .addClass('banner__iframe')
      .addAttribute('src', this.#getParsedURL())
      .appendTo(iframeWrapper.DOMElement);

    new BaseElement('button')
      .addClass('prepayment__close-btn','icon-close')
      .event('click', () => { iframeContainer.remove() })
      .appendTo(iframeWrapper.DOMElement);

    iframe.DOMElement.onload = () => this.#removePreloader();
  }

  #openTab() {
    open(this.#configData.actionButton.url, "_blank");
  }

  #getParsedURL() {
    const url = new URL(this.#configData.actionButton.url);
    if (url.pathname === '/PaymentGateWay/NewWizard/')
      url.pathname += `${getCurrentLang()}/`;

    const clientId = getUrlParam('clientId');
    if (clientId)
      url.search += `&i=${clientId}`;

    return url;
  }

  #addPreloader(parent,customClass) {
    this.#preloader = new DreamsPreloader(parent,customClass).show();
  }

  #removePreloader() {
    this.#preloader && this.#preloader.remove();
    this.#preloader = null;
  }

  #addTranslationToElement(element, translations) {
    element
      .addClass('language-string')
      .innerHtml(changeLangToCurrent(translations[getCurrentLang()]))

    for (const key in translations) {
      element.addAttribute(`data-lang-${key}`, translations[key])
    }
  }

  #show() {
    gsap.fromTo(
      this.#root.DOMElement,
      {
        scale: 0,
      },
      {
        duration: 0.75,
        scale: 1,
        onStart: () => {
          this.#root.removeClass('hidden')
        },
        onComplete: () => {
          this.#root.DOMElement.style = '';
        }
      }
    )
  }
}
